import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Tooltip,
  tooltipClasses,
  styled,
  ClickAwayListener,
  useMediaQuery,
} from "@mui/material";
import { carloanCalculatorData } from "./carLoanBTData.js";
import { Link } from "react-router-dom";
import Collaborators from "./Collaborators/Collaborators.jsx";
import StepOne from "./Steps/StepOne/StepOne.jsx";
import StepTwo from "./Steps/StepTwo/StepTwo.jsx";
import Calculator from "./Calculator/Calculator.jsx";
import "./CarLoanBTCalculator.css";
import FAQ from "./FAQ/FAQ.jsx";
import SideBar from "./SideBar/SideBar.jsx";
import CheckEligibilityBanner from "./CheckEligibilityBanner/CheckEligibilityBanner.jsx";
import MoreLikeThis from "./MoreLikeThis/MoreLikeThis.jsx";

const CarLoanBTCalculator = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const isSmallScreen = useMediaQuery("(max-width:576px)");
  const [openDiscloser, setOpenDiscloser] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const handeDiscloserTooltipClose = () => {
    setOpenDiscloser(false);
  };

  const handeDiscloserTooltipOpen = () => {
    setOpenDiscloser(true);
  };

  // useEffect for scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      // Check if the scroll position is greater than 36rem (576px * 36)
      if (window.scrollY > 35 * 16 && !showSidebar) {
        setShowSidebar(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showSidebar]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const advertiserData = (
    <div>
      <Typography>
        Minemi partners with trusted lenders, and we may receive compensation
        when you click on links or take action on their site. However, this does
        not affect our evaluations or ratings. Our opinions are our own.
      </Typography>
          
    </div>
  );
  return (
    <>
      <div id="personal_loan_repayment_container">
        <section className="">
          <section
            id="loan_calculator_section"
            className="w-100
          "
          >
            <section>
              <p className="pages_links bg-transparent links ">
                <Link
                  to="/"
                  underline="hover"
                  className="bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Home
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  to="/calculators"
                  underline="hover"
                  className="d-none d-md-inline bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Calculators
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  to="/calculators/balance-transfer-calculators"
                  underline="hover"
                  className="d-none d-md-inline bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Balance Transfer Calculator
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  underline="hover"
                  className="d-none d-md-inline fw-bold bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Car Loan Balance Transfer EMI Calculator{" "}
                </Link>{" "}
              </p>
              {/* loan calculation hero section data */}

              {carloanCalculatorData &&
                carloanCalculatorData.map((item, index) => (
                  <div
                    key={index}
                    className="contents bg-transparent mt-3 my-lg-4"
                  >
                    <div className=" mt-4 mt-lg-5 ">
                      <div id="advertiser__discloser">
                        <ClickAwayListener
                          onClickAway={handeDiscloserTooltipClose}
                        >
                          <div className="w-auto">
                            <LightTooltip
                              arrow
                              open={openDiscloser}
                              title={<div>{advertiserData}</div>}
                            >
                              <div>
                                <Link
                                  underline="hover"
                                  style={{
                                    fontSize: 13,
                                    lineHeight: "20px",
                                    fontFamily: "'Archivo', sans-serif",
                                  }}
                                  onClick={handeDiscloserTooltipOpen} // Only this triggers tooltip to open
                                >
                                  Advertiser disclosure
                                </Link>
                              </div>
                            </LightTooltip>
                          </div>
                        </ClickAwayListener>
                      </div>

                      <div className="content_heading d-flex flex-column align-items-start mt-2">
                        <Typography
                          className="bg-transparent archivo fw-bold"
                          sx={{
                            fontSize: {
                              xs: "32px",
                              sm: "35.4312px",
                              md: "40.2752px",
                              lg: "53.1927px",
                            },
                            lineHeight: {
                              xs: "38px",
                              sm: "42.0745px",
                              md: "47.8268px",
                              lg: "63.1663px",
                            },
                            letterSpacing: "0.04px",
                            textAlign: "start",
                            fontFamily: "'Archivo', sans-serif",
                          }}
                        >
                          {item.heading}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 16,
                            lineHeight: "24px",
                            letterSpacing: "0.08px",
                            fontFamily: "'Archivo',sans-serif",
                          }}
                          className="sub-heading bg-transparent my-2 archivo"
                        >
                          {item.subHeading}
                        </Typography>
                      </div>
                    </div>
                  </div>
                ))}
            </section>
            <section className="calculator_section">
              <Calculator />
            </section>
          </section>
          <section className="personal_loan_repayment_page gap-5 mt-5">
            <section id="personal_loan_repayment_content_data" className="m-0 ">
              <section className=" ">
                {/* loan refinance hero section data */}

                {carloanCalculatorData &&
                  carloanCalculatorData.map((item, index) => (
                    <div key={index} className="contents bg-transparent">
                      <div className="  mt-lg-0 ">
                        {/* <div>
                        <img
                          src="loan_refinance.jpg"
                          alt=""
                          className="hero-img"
                        />
                      </div> */}
                        <Typography
                          sx={{
                            fontSize: 36,
                            lineHeight: "42px",
                            letterSpacing: "0.04px",
                            fontFamily: "'Archivo',sans-serif",
                          }}
                        >
                          {item.headingTwo}
                        </Typography>
                        <div className="notice rounded">
                          <Typography
                            sx={{
                              fontSize: "11.008px",
                              lineHeight: "16.512px",
                              letterSpacing: "0.64px",
                              textAlign: "start",
                              // color: "#ffffff",
                              // color: "#000",
                              color: "#8A8A8A",
                              fontFamily: "'Archivo', sans-serif",
                            }}
                            className="notic_text bg-transparent archivo  p-2 my-3"
                          >
                            {item.notice}
                          </Typography>
                        </div>
                      </div>
                      <div id="updation_content" className="mt-4">
                        <div className="d-flex">
                          <p className="updation_heading archivo">
                            {item.updationText}{" "}
                            <span className="archivo">
                              &nbsp;{item.updateTime}
                            </span>
                          </p>
                        </div>
                        <div>
                          <Collaborators />
                        </div>
                      </div>
                    </div>
                  ))}
              </section>
              <section id="step_one">
                <StepOne />
              </section>
              <section id="step_two">
                <StepTwo />
              </section>
              <section className="mt-3">
                <FAQ />
              </section>
            </section>
            <aside
              id="personal_side_bar__container"
              className={`${showSidebar ? "show-sidebar" : "hide-sidebar"}`}
            >
              <div className={`side_bar `}>
                <SideBar />
              </div>
            </aside>
          </section>
          <section>
            <CheckEligibilityBanner />
          </section>
          <section>
            <MoreLikeThis />
          </section>
        </section>
      </div>
    </>
  );
};

export default CarLoanBTCalculator;
